const circleDeltaHack = 0.00000001;
const rectDeltaHack = 1;

const createRoundedRectMask = (el) => {
  const mask = el.mask || new PIXI.Graphics();
  mask.clear();
  mask.beginFill(0x0, 1);
  mask.drawRect(0, 0, el.displayData.width, el.displayData.height);
  mask.arc(el.displayData.width, el.displayData.height / 2, el.displayData.height / 2, Math.PI * 2, Math.PI * 2 + circleDeltaHack, true);
  mask.endFill();
  el.addChild(mask);
  el.mask = mask;
};

const updateRoundedRectMask = (el, maskWidth) => {
  const mask = el.mask || new PIXI.Graphics();
  mask.clear();
  mask.beginFill(0x0, 1);
  mask.drawRect(0, 0, maskWidth + rectDeltaHack, el.displayData.height);
  mask.arc(maskWidth + rectDeltaHack, el.displayData.height / 2, el.displayData.height / 2, Math.PI * 2, Math.PI * 2 + circleDeltaHack, true);
  mask.endFill();
  el.addChild(mask);
  el.mask = mask;
};

const createRectMask = (el, width = 0) => {
  const mask = el.mask || new PIXI.Graphics();
  mask.clear();
  mask.beginFill(0x0, 1);
  mask.drawRect(0, 0, width, el.displayData.height);
  mask.endFill();
  el.addChild(mask);
  el.mask = mask;
};

export const updateRectMaskByWidth = (el, progress) => {
  const deltaHack = 1;
  const mask = el.mask || new PIXI.Graphics();
  mask.clear();
  mask.beginFill(0x0, 1);
  mask.drawRect(el.displayData.width / 2 - ((el.displayData.width * progress / 100 + deltaHack) / 2), 0, el.displayData.width * progress / 100 + deltaHack, el.displayData.height);
  mask.endFill();
};

export default {
  createRoundedRectMask,
  updateRoundedRectMask,
  createRectMask,
  updateRectMaskByWidth,
}
